import React, { useState } from 'react';
import axios from 'axios';
import { renderWheelSvg } from '../chart2/render/renderWheelSvg';
import './Charts2.css';

function Charts2() {
  const [formData, setFormData] = useState({
    date: '17.10.1977',
    time: '20:05',
    timezone: 'Europe/Helsinki',
    lat: '60.1666',
    lng: '24.9435',
  });
  
  const [chart, setChart] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setChart(null);

    try {
      const response = await axios.post('/api/chart2', {
        date: formData.date,
        time: formData.time,
        timezone: formData.timezone,
        lat: parseFloat(formData.lat),
        lng: parseFloat(formData.lng),
      });

      if (response.data.ok && response.data.chart) {
        setChart(response.data.chart);
      } else {
        setError(response.data.error || 'Failed to generate chart');
      }
    } catch (err) {
      console.error('Chart generation error:', err);
      setError(err.response?.data?.error || err.message || 'Failed to generate chart');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadSvg = () => {
    if (!chart) return;
    
    const svgString = renderWheelSvg(chart, { size: 800 });
    const blob = new Blob([svgString], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'natal-chart.svg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="charts2-container">
      <h1>Natal Chart Generator</h1>
      
      <form onSubmit={handleSubmit} className="charts2-form">
        <div className="form-group">
          <label htmlFor="date">Päivämäärä (DD.MM.YYYY)</label>
          <input
            type="text"
            id="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            placeholder="17.10.1977"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="time">Aika (HH:MM)</label>
          <input
            type="text"
            id="time"
            name="time"
            value={formData.time}
            onChange={handleChange}
            placeholder="20:05"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="timezone">Aikavyöhyke</label>
          <input
            type="text"
            id="timezone"
            name="timezone"
            value={formData.timezone}
            onChange={handleChange}
            placeholder="Europe/Helsinki"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="lat">Leveysaste</label>
          <input
            type="number"
            id="lat"
            name="lat"
            value={formData.lat}
            onChange={handleChange}
            step="0.0001"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="lng">Pituusaste</label>
          <input
            type="number"
            id="lng"
            name="lng"
            value={formData.lng}
            onChange={handleChange}
            step="0.0001"
            required
          />
        </div>
        
        <button type="submit" disabled={loading}>
          {loading ? 'Ladataan...' : 'Luo natal chart'}
        </button>
      </form>

      {error && (
        <div className="error-message">
          <p>Virhe: {error}</p>
        </div>
      )}

      {chart && (
        <div className="chart-display">
          <div className="chart-svg-container">
            <div
              dangerouslySetInnerHTML={{
                __html: renderWheelSvg(chart, { size: 800 }),
              }}
            />
          </div>
          
          <div className="chart-actions">
            <button onClick={handleDownloadSvg} className="download-btn">
              Download SVG
            </button>
          </div>

          <div className="chart-tables">
            <div className="table-container">
              <h2>Huoneiden kärjet</h2>
              <table className="chart-table">
                <thead>
                  <tr>
                    <th>Huone</th>
                    <th>Merkki</th>
                    <th>Asteet</th>
                    <th>Minuutit</th>
                  </tr>
                </thead>
                <tbody>
                  {chart.houses.map((house) => (
                    <tr key={house.house}>
                      <td>{house.house}</td>
                      <td>{house.sign}</td>
                      <td>{house.deg}°</td>
                      <td>{house.min}'</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="table-container">
              <h2>Planeettasijainnit</h2>
              <table className="chart-table">
                <thead>
                  <tr>
                    <th>Planeetta</th>
                    <th>Merkki</th>
                    <th>Asteet</th>
                    <th>Minuutit</th>
                  </tr>
                </thead>
                <tbody>
                  {chart.planets.map((planet) => (
                    <tr key={planet.key}>
                      <td>
                        <span className="planet-glyph">{planet.glyph}</span> {planet.nameFi}
                      </td>
                      <td>{planet.sign}</td>
                      <td>{planet.deg}°</td>
                      <td>{planet.min}'</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Charts2;
